import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
export const badgeKindToMidasClassName = (kind) => ({
    primary: midas.badgePrimary,
    danger: midas.badgeDanger,
    warning: midas.badgeWarning,
    success: midas.badgeSuccess,
    info: midas.badgeInfo,
    style: midas.badgeStyle,
}[kind]);
const Badge = ({ children, label = '', kind, dataCy }) => (React.createElement("span", { className: classNames(midas.badge, kind && badgeKindToMidasClassName(kind)), "data-badge": label, "data-cy": dataCy }, children));
export default Badge;
